ngOUC.factory('Favorites', function ($resource, $log) {
    $log.debug('Factory: Favorites');

    return {
        favorite: function () {

        }
    };
});

ngOUC.factory('Properties', function ($resource, $log) {
    $log.debug('Factory: Properties');

    return {
        // Fetch data from the remote source and store it locally
        fetch: function () {
            $log.debug('Properties.fetch()');

            // Our local data store is in OucGlobals.properties . I feel like there should be a smarter, local place for
            // that data but haven't figured it out yet. -Aaron 8/5/2015

            // If OucGlobals.properties is empty, we need to populate it for the first time. On subsequent requests we
            // will return the cached data
            if (OucGlobals.properties.length < 1) {
                $log.debug('-- First time, fetching from network');

                // Execute the request and capture the data
                OucGlobals.properties = $resource(OucGlobals.apiUrl, {}, {
                    query: {method: 'GET', params: {}, isArray: true}
                }).query().$promise;

                // A little helper function for verifying a property of an object exists with a nice value in it
                function exists(thing) {
                    return typeof thing !== 'undefined' && thing.length > 0 && thing !== '';
                }

                // Iterate over the returned items and decorate it with derived values
                OucGlobals.properties.then(function (properties) {
                    angular.forEach(properties, function (property, index) {
                        // Add a collapsed array of images
                        property.imageArray = [];

                        if (exists(property.image1)) {
                            property.imageArray.push(property.image1);
                        }
                        if (exists(property.image2)) {
                            property.imageArray.push(property.image2);
                        }
                        if (exists(property.image3)) {
                            property.imageArray.push(property.image3);
                        }
                        if (exists(property.image4)) {
                            property.imageArray.push(property.image4);
                        }
                        if (exists(property.description)) {
                            property.description_lower_first = property.description.charAt(0).toLowerCase() + property.description.slice(1);
                        }

                        property.url = location.protocol + '//' + location.host + location.pathname + '#/' + property.id;

                        // Update the entry
                        OucGlobals.properties[property.id] = property;
                    });
                });
            } else {
                $log.debug('-- Serving from cache');
            }

            // Finally return the value of OucGlobals.properties .
            return OucGlobals.properties;
        },

        // Get all properties, filtered
        all: function (callback, filter) {
            $log.debug('Properties.all(), with filter', filter);

            // Special handling for the psuedo keys "forsale" and "forlease"
            delete filter.forsale;
            delete filter.forlease;

            if (filter.saleorlease == 'sale') {
                filter.forsale = 1;
            }

            if (filter.saleorlease == 'lease') {
                filter.forlease = 1;
            }

            // Fetch the properties
            this.fetch().then(function (properties) {

                // Prepare a list of filtered properties. The filter may be "no filter," which will return everything
                filteredProperties = [];

                // Iterate over the properties and decide whether it will be included in the filtered set or not
                angular.forEach(properties, function (property) {
                    // By default, we assume every property will be included in the filtered set
                    var include_this_property_in_filtered_set = true;

                    // If any of the keys in filter are a mismatch, disqualify this property
                    angular.forEach(filter, function (filter_value, filter_key) {
                        if (filter_key != 'industry' && filter_key in property && property[filter_key] != filter_value) {
                            include_this_property_in_filtered_set = false;
                        }
                    });

                    // industry is possibly a collection 
                    if ('industry' in filter && property.industry.toLowerCase().indexOf(filter.industry.toLowerCase()) === -1) {
                        include_this_property_in_filtered_set = false;
                    }

                    // If nothing above disqualified the property, add it to the list of filtered properties
                    if (include_this_property_in_filtered_set) {
                        filteredProperties.push(property);
                    }
                });

                // Execute the passed callback
                callback(filteredProperties);
            });
        },

        // Get a single property
        one: function (id, callback) {
            $log.debug('Properties.one(), with id', id);

            // Fetch the properties
            this.fetch().then(function (properties) {
                // Iterate over the results
                angular.forEach(properties, function (value) {
                    // When the matching ID is found, execute the passed callback on it
                    if (value.id === id) {
                        callback(value);
                    }
                });
            });
        }
    };
});
